import { render, staticRenderFns } from "./extraElement.vue?vue&type=template&id=a29fc9b6&scoped=true"
import script from "./extraElement.vue?vue&type=script&lang=js"
export * from "./extraElement.vue?vue&type=script&lang=js"
import style0 from "./extraElement.vue?vue&type=style&index=0&id=a29fc9b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29fc9b6",
  null
  
)

export default component.exports